import { render, staticRenderFns } from "./PuzzleForm.vue?vue&type=template&id=164b70ce&scoped=true&"
import script from "./PuzzleForm.vue?vue&type=script&lang=js&"
export * from "./PuzzleForm.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleForm.vue?vue&type=style&index=0&id=164b70ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164b70ce",
  null
  
)

export default component.exports